export function pick(keys) {
  return (obj) => {
    obj = obj || {};
    return (keys || []).filter((key) => typeof obj[key] !== "undefined").reduce((newObj, key) => Object.assign(newObj, { [key]: obj[key] }), {});
  };
}
